// src/pages/barista/BaristaScreen.jsx
// Barista screen page component

import { useState, useEffect } from 'react'
import BaristaInterface from '../../components/barista/BaristaInterface'
import { Navigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import WhiteSpinner from '../../components/ui/WhiteSpinner'

const BaristaScreen = ({ user, onLogout }) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    console.log('🔍 BaristaScreen: User info:', {
      role: user?.role,
      branchId: user?.branchId,
      isSuperAdmin: user?.role === 'superadmin' || user?.role === 'super_admin'
    })
    
    // Check if user has barista role
    if (!user) {
      setLoading(false)
      return
    }

    // Allow barista, admin, manager, and superadmin roles (including super_admin variant)
    const allowedRoles = ['barista', 'admin', 'manager', 'superadmin', 'super_admin']
    if (!allowedRoles.includes(user.role)) {
      toast.error('Access denied. Barista, Admin, Manager, or Super Admin role required.')
      setLoading(false)
      return
    }

    // Check if user has branch assigned (not required for superadmin/super_admin)
    if (user.role !== 'superadmin' && user.role !== 'super_admin' && user.role !== 'admin' && !user.branchId) {
      toast.error('No branch assigned. Please contact administrator.')
      setLoading(false)
      return
    }

    setLoading(false)
  }, [user])

  // Show loading while checking permissions
  if (loading) {
    return (
      <div className="min-h-screen bg-orange-500 flex items-center justify-center">
        <div className="text-center text-white">
          <WhiteSpinner className="mx-auto mb-4" />
          <p>Loading barista interface...</p>
        </div>
      </div>
    )
  }

  // Redirect non-authorized users
  const allowedRoles = ['barista', 'admin', 'manager', 'superadmin', 'super_admin']
  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/login" replace />
  }

  // Show error if no branch assigned (except for superadmin and admin)
  if (user.role !== 'superadmin' && user.role !== 'super_admin' && user.role !== 'admin' && !user.branchId) {
    return (
      <div className="min-h-screen bg-orange-500 flex items-center justify-center">
        <div className="text-center text-white">
          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl">⚠️</span>
          </div>
          <h2 className="text-2xl font-bold mb-2">No Branch Assigned</h2>
          <p className="text-orange-200">Please contact your administrator to assign a branch.</p>
        </div>
      </div>
    )
  }

  return (
    <BaristaInterface 
      user={user} 
      branchId={user.branchId} // Pass actual branchId or undefined for superadmin
      onLogout={onLogout}
    />
  )
}

export default BaristaScreen
